import api from '../../tools/api-tools'
import resUrl from './resource-url'
// import './index.mock'

class UserAddress {
  loadData () {
    return new Promise((resolve, reject) => {
      api.get(resUrl.index).then(res => {
        let data = res.data
        if (data.code === 0) {
          let objData = data.data
          let userAddressObj = {
            userName: objData.consigneeName,
            userPhone: objData.telNumber,
            userAddress: [objData.proviceName, objData.cityName, objData.countryName],
            userAddressIds: [objData.proviceId, objData.cityId, objData.countryId],
            userAddressDetail: objData.addressDetail
          }
          resolve(userAddressObj)
        } else {
          reject('e')
        }
      }).catch(e => {
        reject(e)
      })
    })
  }

  saveData (userAddressObj) {
    return new Promise((resolve, reject) => {
      let form = {
        ConsigneeName: userAddressObj.userName,
        TelNumber: userAddressObj.userPhone,
        ProviceName: userAddressObj.userAddress[0] || '',
        ProviceId: userAddressObj.userAddressIds[0] || '',
        CityName: userAddressObj.userAddress[1] || '',
        CityId: userAddressObj.userAddressIds[1] || '',
        CountryName: userAddressObj.userAddress[2] || '',
        CountryId: userAddressObj.userAddressIds[2] || '',
        AddressDetail: userAddressObj.userAddressDetail
      }
      api.post(resUrl.index, form).then(res => {
        if (res.data.code === 0) {
          resolve()
        } else {
          reject(new Error('api error'))
        }
      }).catch(e => {
        reject(e)
      })
    })
  }
}

export default UserAddress



// WEBPACK FOOTER //
// ./src/model/user-address/index.js